import { memo } from "react";

type ForwardedDateTimeFormatOptions =
  | Pick<Intl.DateTimeFormatOptions, "dateStyle" | "timeStyle">
  | Pick<
      Intl.DateTimeFormatOptions,
      | "day"
      | "month"
      | "year"
      | "hour"
      | "minute"
      | "second"
      | "timeZone"
      | "timeZoneName"
      | "weekday"
      | "hour12"
    >;

export const FormattedDate = memo(
  ({
    className,
    value,
    ...options
  }: {
    value: string | Date;
    className?: string;
  } & ForwardedDateTimeFormatOptions) => {
    const date = new Date(value);
    const formattedDate = date.toLocaleString(navigator.languages, options);

    return (
      <time className={className} dateTime={date.toISOString()}>
        {formattedDate}
      </time>
    );
  },
);

FormattedDate.displayName = "FormattedDate";
